import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from 'src/app/shared/enums/enums'
import { DdcTabsChipsComponent } from '../../shared/ddc-tabs-chips/ddc-tabs-chips.component'
import { DdcSettingAccountComponent } from '../ddc-setting-account/ddc-setting-account.component'
import { DdcSettingBillingAndPlansComponent } from '../ddc-setting-billing-and-plans/ddc-setting-billing-and-plans.component'
import { DdcSettingProfileComponent } from '../ddc-setting-profile/ddc-setting-profile.component'

@Component({
  selector: 'ddc-setting',
  templateUrl: './ddc-setting.component.html',
  styleUrls: ['./ddc-setting.component.scss'],
  imports: [
    AngularMaterialsModules,
    CommonModule,
    RouterModule,
    DdcSettingAccountComponent,
    DdcSettingBillingAndPlansComponent,
    DdcSettingProfileComponent,
    DdcTabsChipsComponent,
  ],
  standalone: true,
})
export class DdcSettingComponent {
  activeSection: string = 'profile' // Default section

  private themeSubscription: Subscription
  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false

  navigate(section: string): void {
    this.activeSection = section
  }

  constructor(public themeService: ThemeService) {
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
  }
}
